import React from "react";
import { Grid, Box } from "@mui/material";
import LeftPanel from "../../LeftPanel/LeftPanel";
import RightPanel from "../../RightPanel/RightPanel";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { getCurrencyBasedOnSiteContext } from "../../../../utils/helpers";
import { setCurrency } from "../../../../redux/slice/campaignSlice";

const JobPreview = () => {
    const siteContext = useSelector((state: RootState) => state.campaign.userData.siteContext);
    const currency = useSelector((state:RootState)=>state.campaign.currency)
    const dispatch = useDispatch()
    React.useEffect(() => {
      const defaultCurrency = currency ? currency : getCurrencyBasedOnSiteContext(siteContext);
        dispatch(setCurrency({currency: defaultCurrency}));
    },[siteContext])
  return (
    <Grid container padding={"16px"} gap={"16px"}>
      <Grid item width="349px">
      <Box>
          <LeftPanel />
          </Box>
      </Grid>

      <Grid item width="509px">
      <Box>
          <RightPanel />
          </Box>
      </Grid>
    </Grid>
  );
};

export default JobPreview;
